// Theme-Aware Layout Constants
// Purpose: Keeps the narrow gap geometry used to reveal page themes consistent across layouts.
// Scope: Layout-only values; selecting a theme never changes panel dimensions or input placement.

export const themeGapClass = 'gap-0.5';
export const themeStackClass = 'space-y-1';
